import React from "react";
import PropTypes from "prop-types";
import { ProgressBar } from "react-bootstrap";

const ProjectProgressCart = (props) => (
	<div className={`project-card ${props.class}`}>
		<h3 className="card-title">{props.name}</h3>
		{ 	(props.progress!==null && props.progress>=0) ?
			<ProgressBar bsStyle="success" now={props.progress > 100 ? 100 : props.progress}  label={`${props.progress}%`} />
			:
			<h5>Can not calculate progress!</h5>
		}
	</div>		 
);

ProjectProgressCart.defaultProps = {
	progress: null,
	name: "",
};

ProjectProgressCart.propTypes = {
	name: PropTypes.string,
	progress: PropTypes.number,
	class: PropTypes.string.isRequired
};

export default ProjectProgressCart;



// WEBPACK FOOTER //
// ./src/components/pages/projects/ProjectProgressCart.js